import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useMemo } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import DataTable from "../../../containers/DataTable";

import xmlAPICall from '../../../app/apiCalls/xmlAPICall'
import { xml_cam_upload, xml_cams_list } from "../../../app/apiEndpoints"

import { Card, Row, Col } from 'react-bootstrap'
import InvalidPermissions from '../../../containers/InvalidPermissions'

const XMLSection = (props) => {
    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const [file, setFile] = useState(null);
    const [uploadMessage, setUploadMessage] = useState('')

    const [data, setData] = useState([])
    const [config, setConfig] = useState(null)

    const tableID = "tool"
    const tableFields = ["Keyword", "Status", "# Online", "# in List", "Last Checked", ""]

    useMemo(() => {
        const getData = async () => {
            const data = await xmlAPICall(xml_cams_list, {'requester': userID, 'company': companyID, 'status': (isSysadmin ? 0 : 1) })
            setData(data.data)
            if(data.config) setConfig(data.config)
        }
        getData()
    }, [userID, companyID, isSysadmin])

    const tableData = () => {
        if(data.length === 0) {
            return [];
        } 
        let rows = [];
        data.forEach(row => {
            rows.push({'id': row.keyword, 'values': [
                row.keyword,
                row.status === "1" ? "🟢" : "🔴",
                row.models_online,
                row.models_total,
                row.last_checked,
                `<a href="https://api.toplineadsportal.com/xml/stripchat/?key=${row.keyword}&redir=" target="_blank" class="btn btn-primary btn-sm">View</a>`
            ]});
        });
        return rows
    }

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };
    
    const handleUpload = async () => {
        if (!file) return alert("Please select a file first");

        const data = await xmlAPICall(xml_cam_upload, { 'requester': userID, 'company': companyID, 'file': file})
        if(data.error) {
            setUploadMessage(data.error)
        } 
        else {
            setUploadMessage("File updated")
        }
    };

    if(!isSysadmin) return <InvalidPermissions />

    return (
        <>
        <Card>
            <CardHeader title="Cams XML Feeds" description="View current Cams feeds and upload new config file" />
            <Card.Body>
            <Row>
                <Col md={12}>
                <DataTable hover={true} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} />
                
                </Col>
            </Row>
            </Card.Body>
        </Card>

        <Card className='mt-4'>
            <CardHeader title="Cams XML Configuration File" description="View current configuration" />
            <Card.Body>
            <Row>
                <Col md={12}>
                    <Row>
                        <Col md={12} style={{ maxWidth: "100%"}}>
                            <pre>{config}</pre>
                        </Col>
                    </Row>

                    <b>Upload New Config File</b>
                    <Row>
                        <Col sm={8}>
                        
                        <input
                            type="file"
                            accept=".json,application/json"
                            onChange={handleFileChange}
                            className="form-control"
                        />
                        </Col>
                        <Col sm={4}>
                            {uploadMessage && uploadMessage.length > 0 && uploadMessage}
                            {(!uploadMessage || uploadMessage.length === 0) && <button onClick={handleUpload} className='btn btn-primary'>Upload</button> }
                        </Col>
                    </Row>
                </Col>
            </Row>
            </Card.Body>
        </Card>
        </>
    )
}
export default connect(state => ({...state}))(pageWithSideMenu(pageContent(XMLSection), "XML Content"));

